export const formControl = {
  root: {
    '&:not(:last-child)': {
      marginBottom: '1.25rem',
    },
  },
};
